module.exports = "/img/3.svg?c839b0cdfe117ec34fc261e00709a935";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/spinner/img/3.svg
// module id = 1v2r
// module chunks = 83